// extracted by mini-css-extract-plugin
export default {"pageTabs":"NavBar_pageTabs__Lg+re","pageTab":"NavBar_pageTab__lVhcM","pageTab_active":"NavBar_pageTab_active__dL5wk","pageTab_inactive":"NavBar_pageTab_inactive__dp4FA"};